<script lang="ts">import Cart from './Cart/Cart.svelte';
import CartButton from './CartButton/CartButton.svelte';
import Link from '../../../shared/Link/Link.svelte';
import LinkList from '../../../shared/LinkList/LinkList.svelte';
import ImageListCategory from '../../../shared/ImageListCategory/ImageListCategory.svelte';
import SearchBar from '../../../../Search/SearchBar.svelte';
import SearchTrigger from './SearchTrigger.svelte';
import { getSearchOptionsStore } from '../../../../Search/SearchProvider.svelte';
import AskSquareNavTrigger from './AskSquareNavTrigger.svelte';
import { getComponentType } from '../../../../../js-v2/componentUtils';
import { mobileNavStateStore } from '../../../../../js-v2/stores/mobile-nav-stores';
import { getLoggedIn, getCartCount } from '../../../../../js-v2/stores/user-state-stores';
import { filterNavItems } from '../../../../../js-v2/navItemFilters';
import { onTouchOrClick } from '../../../../../js-v2/onTouchOrClick';
import { getTracking } from '../../../../../js-v2/tracking';
import { getLocation, getNavDeviceType } from '../../../../../js-v2/trackingUtils';
import { getUrlPath } from '../../../../../js-v2/urlUtils';
const { primaryNavItems = [], secondaryNavItems = [], mobileNavHeight = 0, enableAskSquare = false, cart = undefined, toggleAskSquare = () => { }, } = $props();
const searchOptions = getSearchOptionsStore();
const cartCountStore = getCartCount();
const loggedInStore = getLoggedIn();
const trackFn = getTracking();
const filteredPrimaryNavItems = $derived(filterNavItems({
    items: primaryNavItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
}));
const filteredSecondaryNavItems = $derived(filterNavItems({
    items: secondaryNavItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
}));
let clientHeight = $state(0);
let dropdownEl = $state();
let searchInputEl = $state();
function openCategory(categoryItem) {
    trackFn({
        eventName: 'Open Menu',
        properties: {
            currentPage: getUrlPath(),
            menuId: categoryItem.contentfulEntryId,
            menuText: categoryItem.props?.title,
            menuCategory: categoryItem.props?.title,
            menuLocation: getLocation(dropdownEl),
            navDeviceType: getNavDeviceType(dropdownEl),
        },
    });
    mobileNavStateStore.push({
        type: 'category',
        categoryId: categoryItem.contentfulEntryId,
    });
}
function openSubcategory(subcategoryItem, categoryTitle) {
    trackFn({
        eventName: 'Open Menu',
        properties: {
            currentPage: getUrlPath(),
            menuId: subcategoryItem.contentfulEntryId,
            menuText: subcategoryItem.props?.title,
            menuCategory: categoryTitle,
            menuSubcategory: subcategoryItem.props?.title,
            menuLocation: getLocation(dropdownEl),
            navDeviceType: getNavDeviceType(dropdownEl),
        },
    });
    mobileNavStateStore.push({
        type: 'subcategory',
        subcategoryId: subcategoryItem.contentfulEntryId,
    });
}
function getActiveContent(mobileNavState) {
    if (!mobileNavState) {
        return null;
    }
    const activeContentStack = mobileNavState.activeContentStack;
    if (!activeContentStack || activeContentStack.length === 0) {
        return null;
    }
    return activeContentStack.at(-1);
}
function autoFocusSearchInputOnOpen({ isOpen, activeContentStack }, inputEl) {
    const isSearchOpen = isOpen && activeContentStack.at(-1)?.type === 'search';
    if (isSearchOpen && inputEl) {
        inputEl.focus();
    }
}
$effect(() => {
    autoFocusSearchInputOnOpen($mobileNavStateStore, searchInputEl);
});
const activeContent = $derived(getActiveContent($mobileNavStateStore));
</script>

<div
  bind:this={dropdownEl}
  class="Dropdown"
  class:no-height-transition={!$mobileNavStateStore.showHeightTransition}
  style:height={`${clientHeight}px`}
  style:--dropdown-top-offset={`${mobileNavHeight}px`}
>
  <div bind:clientHeight>
    <div
      class="dropdown-nav-item-container slide-in-from-top"
      class:active={$mobileNavStateStore.isOpen && $mobileNavStateStore.activeContentStack.length === 0}
    >
      {#if filteredPrimaryNavItems.length > 0}
        <ul>
          {#each filteredPrimaryNavItems as primaryNavItem, index}
            {#if ['category', 'imageListCategory'].includes(getComponentType(primaryNavItem.componentName))}
              <li style:--dropdown-item-number={index + 1}>
                <button
                  class="toggle-large"
                  aria-haspopup="true"
                  aria-expanded={primaryNavItem.contentfulEntryId ===
                    getActiveContent($mobileNavStateStore)?.categoryId}
                  aria-controls={`global-nav-mobile-dropdown-content-${primaryNavItem.contentfulEntryId}`}
                  data-entry-id={primaryNavItem.contentfulEntryId}
                  use:onTouchOrClick={() => openCategory(primaryNavItem)}
                >
                  <span>{primaryNavItem.props.title}</span>
                </button>
              </li>
            {:else if getComponentType(primaryNavItem.componentName) === 'link'}
              <li style:--dropdown-item-number={index + 1}>
                <Link
                  linkCustomCssClass="subcategory-large-link"
                  id={primaryNavItem.contentfulEntryId}
                  title={primaryNavItem.props.title}
                  url={primaryNavItem.props.url}
                  linkStyle={primaryNavItem.props.linkStyle}
                  openInNewTab={primaryNavItem.props.openInNewTab}
                />
              </li>
            {/if}
          {/each}
        </ul>
      {/if}

      <ul>
        {#if filteredSecondaryNavItems.length > 0}
          {#each filteredSecondaryNavItems as secondaryNavItem, index}
            {#if getComponentType(secondaryNavItem.componentName) === 'category'}
              <li style:--dropdown-item-number={index + (filteredPrimaryNavItems?.length || 0) + 1}>
                <button
                  class="toggle-small"
                  aria-haspopup="true"
                  aria-expanded={secondaryNavItem.contentfulEntryId ===
                    getActiveContent($mobileNavStateStore)?.categoryId}
                  aria-controls={`global-nav-mobile-dropdown-content-${secondaryNavItem.contentfulEntryId}`}
                  data-entry-id={secondaryNavItem.contentfulEntryId}
                  use:onTouchOrClick={() => openCategory(secondaryNavItem)}
                >
                  {#if secondaryNavItem.props.icon?.svgString}
                    <span class="icon">
                      {@html secondaryNavItem.props.icon?.svgString}
                    </span>
                  {/if}

                  <span>{secondaryNavItem.props.title}</span>
                </button>
              </li>
            {:else if getComponentType(secondaryNavItem.componentName) === 'link'}
              <li style:--dropdown-item-number={index + (filteredPrimaryNavItems?.length || 0) + 1}>
                <Link
                  linkCustomCssClass="link-list-link"
                  id={secondaryNavItem.contentfulEntryId}
                  title={secondaryNavItem.props.title}
                  url={secondaryNavItem.props.url}
                  icon={secondaryNavItem.props.icon}
                  linkStyle={secondaryNavItem.props.linkStyle}
                  openInNewTab={secondaryNavItem.props.openInNewTab}
                />
              </li>
            {/if}
          {/each}
        {/if}

        {#if enableAskSquare}
          <li
            style:--dropdown-item-number={(filteredSecondaryNavItems?.length || 0) +
              (filteredPrimaryNavItems?.length || 0) +
              2}
          >
            <AskSquareNavTrigger {toggleAskSquare} />
          </li>
        {/if}

        {#if $searchOptions.isEnabled && !enableAskSquare}
          <li
            style:--dropdown-item-number={(filteredSecondaryNavItems?.length || 0) +
              (filteredPrimaryNavItems?.length || 0) +
              2}
          >
            <SearchTrigger />
          </li>
        {/if}

        {#if cart}
          <li
            style:--dropdown-item-number={(filteredSecondaryNavItems?.length || 0) +
              (filteredPrimaryNavItems?.length || 0) +
              1}
          >
            <CartButton id={cart.contentfulEntryId} title={cart?.props?.mobileTitle} />
          </li>
        {/if}
      </ul>
    </div>

    {#each filteredPrimaryNavItems as primaryNavItem}
      {#if primaryNavItem?.props?.primaryNavItems?.length > 0 || primaryNavItem?.props?.secondaryNavItems?.length > 0 || primaryNavItem?.props?.navItems?.length > 0}
        <div
          id={`global-nav-mobile-dropdown-content-${primaryNavItem.contentfulEntryId}`}
          class="dropdown-nav-item-container dropdown-subcategory-nav-item-container slide-in-from-left"
          class:active={primaryNavItem.contentfulEntryId === getActiveContent($mobileNavStateStore)?.categoryId}
          data-category={primaryNavItem?.props?.title}
          data-entry-id={primaryNavItem.contentfulEntryId}
        >
          {#if primaryNavItem.componentName === 'PublicWebNavigationImageListCategoryV2'}
            <ImageListCategory
              id={primaryNavItem?.contentfulEntryId}
              title={primaryNavItem?.props?.title}
              navItems={primaryNavItem?.props?.navItems}
              alignment="center"
              containerSize="large"
              slideInFrom="left"
            />
          {:else}
            <ul class="primary-dropdown-nav-item-list">
              <li style:--dropdown-item-number={1}>
                <span class="title">
                  {primaryNavItem?.props?.title}
                </span>
              </li>
              {#each primaryNavItem.props.primaryNavItems as subcategory, index}
                {#if ['category', 'imageListCategory'].includes(getComponentType(subcategory.componentName))}
                  <li style:--dropdown-item-number={index + 2}>
                    <button
                      class="toggle-large"
                      aria-haspopup="true"
                      aria-expanded={subcategory.contentfulEntryId ===
                        getActiveContent($mobileNavStateStore)?.subcategoryId}
                      aria-controls={`global-nav-mobile-dropdown-content-${subcategory.contentfulEntryId}`}
                      data-entry-id={subcategory.contentfulEntryId}
                      use:onTouchOrClick={() => openSubcategory(subcategory, primaryNavItem?.props?.title)}
                    >
                      <span>{subcategory.props.title}</span>
                    </button>
                  </li>
                {:else if getComponentType(subcategory.componentName) === 'link'}
                  <li style:--dropdown-item-number={index + 2}>
                    <Link
                      linkCustomCssClass="subcategory-small-link"
                      id={subcategory.contentfulEntryId}
                      title={subcategory.props.title}
                      url={subcategory.props.url}
                      linkStyle={subcategory.props.linkStyle}
                      openInNewTab={subcategory.props.openInNewTab}
                    />
                  </li>
                {/if}
              {/each}
            </ul>
            <ul class="secondary-dropdown-nav-item-list">
              {#each primaryNavItem.props.secondaryNavItems as link, index}
                <li style:--dropdown-item-number={index + (primaryNavItem?.props?.primaryNavItems?.length || 0) + 1}>
                  <Link
                    linkCustomCssClass="subcategory-small-link"
                    id={link.contentfulEntryId}
                    title={link.props.title}
                    url={link.props.url}
                    linkStyle={link.props.linkStyle}
                    openInNewTab={link.props.openInNewTab}
                  />
                </li>
              {/each}
            </ul>
          {/if}
        </div>
      {/if}
    {/each}

    {#each filteredPrimaryNavItems as primaryNavItem}
      {#if primaryNavItem?.props?.primaryNavItems}
        {#each primaryNavItem.props.primaryNavItems as subcategory}
          {#if subcategory?.props?.primaryNavItems || subcategory?.props?.navItems}
            <div
              id={`global-nav-mobile-dropdown-content-${subcategory.contentfulEntryId}`}
              class="dropdown-nav-item-container slide-in-from-left"
              class:active={subcategory.contentfulEntryId === getActiveContent($mobileNavStateStore)?.subcategoryId}
              data-category={primaryNavItem?.props?.title}
              data-subcategory={subcategory?.props?.title}
              data-entry-id={subcategory.contentfulEntryId}
            >
              {#if getComponentType(subcategory?.componentName) === 'imageListCategory'}
                <ImageListCategory
                  id={subcategory.contentfulEntryId}
                  title={subcategory.props.title}
                  navItems={subcategory.props.navItems}
                  alignment="center"
                  containerSize="large"
                  slideInFrom="left"
                  showTitle={true}
                />
              {:else if getComponentType(subcategory?.componentName) === 'category'}
                {#each subcategory.props.primaryNavItems as linkListItem, index}
                  <LinkList
                    id={linkListItem.contentfulEntryId}
                    navItems={linkListItem.props.primaryNavItems}
                    title={linkListItem.props.title}
                    linkStartingIndex={subcategory?.props?.primaryNavItems[index - 1]?.props?.primaryNavItems?.length ||
                      0}
                    slideInFrom="left"
                  />
                {/each}
              {/if}
            </div>
          {/if}
        {/each}
      {/if}
    {/each}

    {#each filteredSecondaryNavItems as secondaryNavItem, index}
      {#if secondaryNavItem?.props?.primaryNavItems?.length > 0}
        <div
          id={`global-nav-mobile-dropdown-content-${secondaryNavItem.contentfulEntryId}`}
          class="dropdown-nav-item-container slide-in-from-left"
          class:active={secondaryNavItem.contentfulEntryId === getActiveContent($mobileNavStateStore)?.categoryId}
        >
          {#if secondaryNavItem.componentName === 'PublicWebNavigationCategoryV2'}
            <LinkList
              id={secondaryNavItem.contentfulEntryId}
              navItems={secondaryNavItem.props.primaryNavItems}
              title={secondaryNavItem.props.title}
              linkStartingIndex={filteredSecondaryNavItems[index - 1]?.props?.primaryNavItems?.length || 0}
              slideInFrom="left"
            />
          {/if}
        </div>
      {/if}
    {/each}

    {#if cart}
      <div class="dropdown-nav-item-container" class:active={getActiveContent($mobileNavStateStore)?.type === 'cart'}>
        <Cart
          id={cart.contentfulEntryId}
          statusZero={cart.props.statusZeroItems}
          statusOne={cart.props.statusOneItem}
          statusMany={cart.props.statusManyItems}
          primaryNavItems={cart.props.primaryNavItems}
          secondaryNavItems={cart.props.secondaryNavItems}
          slideInFrom="left"
        />
      </div>
    {/if}

    {#if activeContent?.type === 'search'}
      <div class="search-bar-container" style:--search-item-number={1}>
        <SearchBar bind:inputEl={searchInputEl} />
      </div>
    {/if}
  </div>
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Dropdown {
  position: absolute;
  top: var(--dropdown-top-offset);
  left: 0;
  width: 100%;
  background-color: var(--color-background, var(--color-neutral-1000, #fff));
  overflow: hidden;
  transition: height 300ms cubic-bezier(0.4, 0, 0.6, 1);
}
.Dropdown.no-height-transition {
  transition: none;
}
.Dropdown .dropdown-nav-item-container {
  display: none;
  overflow: auto;
  padding: var(--accessibility-focus-outline-offset) 32px 150px;
}
.Dropdown .dropdown-nav-item-container.slide-in-from-top li {
  opacity: 0;
  transform: translateX(0) translateY(-4px);
}
.Dropdown .dropdown-nav-item-container.slide-in-from-top :global(.LinkList .slide-in-from-top) {
  opacity: 0;
  transform: translateX(0) translateY(-4px);
}
.Dropdown .dropdown-nav-item-container.slide-in-from-left li {
  opacity: 0;
  transform: translateX(-4px) translateY(0);
}
.Dropdown .dropdown-nav-item-container.slide-in-from-left :global(.LinkList .slide-in-from-left) {
  opacity: 0;
  transform: translateX(-4px) translateY(0);
}
.Dropdown .dropdown-nav-item-container.active {
  display: flex;
  flex-direction: column;
  gap: 35px;
  height: calc(100vh - var(--dropdown-top-offset));
}
.Dropdown .dropdown-nav-item-container.active.dropdown-subcategory-nav-item-container {
  gap: 17px;
}
.Dropdown .dropdown-nav-item-container.active.slide-in-from-top li {
  animation: fade-in-slide-from-top 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--dropdown-item-number) * 20ms);
}
.Dropdown .dropdown-nav-item-container.active.slide-in-from-top :global(.LinkList .slide-in-from-top) {
  animation: fade-in-slide-from-top 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--link-list-item-number) * 20ms);
}
.Dropdown .dropdown-nav-item-container.active.slide-in-from-left li {
  animation: fade-in-slide-from-left 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--dropdown-item-number) * 20ms);
}
.Dropdown .dropdown-nav-item-container.active.slide-in-from-left :global(.LinkList .slide-in-from-left) {
  animation: fade-in-slide-from-left 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--link-list-item-number) * 20ms);
}
.Dropdown .dropdown-nav-item-container ul {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
  gap: 10px;
  flex-direction: column;
}
.Dropdown .dropdown-nav-item-container ul > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.Dropdown .dropdown-nav-item-container ul > li::before {
  display: none;
}
.Dropdown .dropdown-nav-item-container ul > li :global(:last-child) {
  margin: 0;
}
.Dropdown .dropdown-nav-item-container .title {
  --letter-spacing: var(--text-variant-50-letter-spacing);
  --line-height: var(--text-variant-50-line-height);
  --font-size: var(--text-variant-50-font-size);
  --font-weight: var(--text-variant-50-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-50-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  display: block;
  width: max-content;
  color: var(--color-neutral-400);
}

.icon {
  display: inline-flex;
  align-items: center;
}
.icon :global(svg *) {
  fill: var(--color-text, var(--color-neutral-000, #000000));
}

.toggle-small {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  padding: 2px 0px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.toggle-small:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.toggle-small:focus {
  background: transparent;
  outline: none;
}
.toggle-small:hover {
  background: transparent;
}

.toggle-large {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  --letter-spacing: var(--text-variant-200-letter-spacing);
  --line-height: var(--text-variant-200-line-height);
  --font-size: var(--text-variant-200-font-size);
  --font-weight: var(--text-variant-200-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-200-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  padding: 5px 0px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.toggle-large:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.toggle-large:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.toggle-large:focus {
  background: transparent;
  outline: none;
}
.toggle-large:hover {
  background: transparent;
}

.search-bar-container {
  padding: 0 28px;
  height: calc(100vh - var(--dropdown-top-offset));
  opacity: 0;
  transform: translateX(-4px) translateY(0);
  animation: fade-in-slide-from-left 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--search-item-number) * 20ms);
}</style>
